// A window/document-level key handler must ignore events aimed at a text field
// or an interactive control, or it hijacks typing and button/link activation.
export function isEditableOrControlTarget(target: EventTarget | null): boolean {
  const el = target as HTMLElement | null
  return (
    !!el &&
    (el.tagName === 'INPUT' ||
      el.tagName === 'TEXTAREA' ||
      el.tagName === 'SELECT' ||
      el.isContentEditable ||
      !!el.closest('button, a, [role="button"]'))
  )
}
